(function () {
  const nav = document.getElementById("rental-sticky-nav");
  let shown = false;
  function onScroll() {
    let scrolled = window.scrollY || window.pageYOffset;
    let trigger = window.innerHeight * 0.5;
    if (scrolled > trigger && !shown) {
      nav.classList.remove("translate-y-[-100%]");
      nav.classList.add("translate-y-0");
      shown = true;
    } else if (scrolled <= trigger && shown) {
      nav.classList.remove("translate-y-0");
      nav.classList.add("translate-y-[-100%]");
      shown = false;
    }
  }
  window.addEventListener("scroll", onScroll, { passive: true });
})();
